import { getCorrectedNow } from './timeSync'

// TOTP 표시 공용 티커 — 잔여초 ±1초 표시 불일치 수정.
// 각 컴포넌트(허브 칩·상세 뷰)가 마운트 시점부터 독립 setInterval(1s)을 돌리면 tick 위상이
// 서로 달라, 같은 시계로 계산해도 순간적으로 잔여초가 ±1초 어긋나 보인다. 모든 표시를
// 하나의 타이머로 같은 순간에 재계산시키면 값이 항상 일치한다.
// 경계는 보정시계(getCorrectedNow) 기준 — 잔여초 자체가 보정시계로 계산되므로
// (createGenerator), 표시가 갱신되는 순간과 값이 실제로 바뀌는 순간이 일치한다.
// 백그라운드 탭 스로틀에도 안전: 매 tick이 절대 시각 기준 재계산+재예약이라 누적 오차가 없다.
const subscribers = new Set()
let timerId = null

function scheduleNextTick() {
  // setTimeout 은 지정 시각 이전에 발화하지 않으므로 경계 "직후" 실행이 보장된다(epsilon 불필요).
  const delay = 1000 - (getCorrectedNow() % 1000)
  timerId = setTimeout(() => {
    subscribers.forEach((cb) => {
      // 한 구독자의 예외가 다른 표시의 갱신과 재예약 루프를 죽이지 않도록 격리 —
      // 개별 setInterval 시절의 컴포넌트 간 격리 수준을 유지한다. 로깅 의존(restClient)을
      // 지지 않는 이유: 이 모듈은 의존 zero 로 유지해 테스트/번들 격리를 보장.
      try {
        cb()
      } catch (e) {
        // 격리하되 흔적은 남긴다(PR #1674 리뷰) — 기존 setInterval 구조에선 throw 가
        // 전역으로 전파돼 콘솔+Sentry 에 남았으므로, 무음 삼킴은 관측 가능성 회귀다.
        // Sentry 직접 호출은 의존 zero 유지(services/restClient 미도입)를 위해 하지 않는다
        // — caught 예외라 Sentry 전역 핸들러엔 안 잡히는 트레이드오프를 감수(콘솔 흔적 복원).
        // eslint-disable-next-line no-console
        console.error('[totp-ticker] subscriber tick failed', e)
      }
    })
    if (subscribers.size > 0) {
      scheduleNextTick()
    } else {
      timerId = null
    }
  }, delay)
}

// cb 를 매 보정시계 초 경계에 호출한다. 반환값은 해지 함수.
// 마지막 구독자가 떠나면 타이머도 멈춘다 — totp 화면을 벗어난 뒤 백그라운드 tick 잔존 방지.
export function subscribeTotpTick(cb) {
  subscribers.add(cb)
  if (timerId == null) {
    scheduleNextTick()
  }
  return () => {
    subscribers.delete(cb)
    if (subscribers.size === 0 && timerId != null) {
      clearTimeout(timerId)
      timerId = null
    }
  }
}

// 테스트 전용: 모듈 스코프 상태 초기화(테스트 간 오염 방지). 프로덕션 코드에서 호출 금지.
export function resetTotpTickerForTest() {
  subscribers.clear()
  if (timerId != null) {
    clearTimeout(timerId)
    timerId = null
  }
}
